export type LabelMap = Record<number, string>;

export const SITUACAO_VEREADOR: LabelMap = { 1: "Em Exercício", 2: "Licenciado", 3: "Suplente" };
export const TIPO_SESSAO: LabelMap = { 1: "Ordinária", 2: "Extraordinária", 3: "Solene" };
export const STATUS_SESSAO: LabelMap = { 1: "Prevista", 2: "Encerrada", 3: "Cancelada" };
export const STATUS_PRESENCA: LabelMap = { 1: "Presente", 2: "Ausente", 3: "Justificada", 4: "Licenciado" };
export const TIPO_PROJETO: LabelMap = { 1: "Projeto de Lei", 2: "Projeto de Resolução", 3: "Projeto de Decreto Legislativo" };
export const TIPO_ATO_NORMATIVO: LabelMap = { 1: "Lei Orgânica", 2: "Lei Ordinária", 3: "Lei Complementar", 4: "Resolução", 5: "Decreto Legislativo" };
export const RESULTADO_VOTACAO: LabelMap = { 1: "Aprovado", 2: "Rejeitado", 3: "Empatado" };
export const VOTO: LabelMap = { 1: "Favorável", 2: "Não Favorável", 3: "Abstenção", 4: "Ausente" };
export const TIPO_ATIVIDADE: LabelMap = { 1: "Autoria", 2: "Relatoria", 3: "Pronunciamento", 4: "Presidência de Comissão" };
export const TIPO_COMISSAO: LabelMap = { 1: "Permanente", 2: "Temporária" };
export const RESULTADO_PRESTACAO_EXECUTIVO: LabelMap = { 1: "Aprovada", 2: "Aprovada com Ressalvas", 3: "Reprovada" };
export const MESES: LabelMap = {
    1: "Janeiro", 2: "Fevereiro", 3: "Março", 4: "Abril", 5: "Maio", 6: "Junho",
    7: "Julho", 8: "Agosto", 9: "Setembro", 10: "Outubro", 11: "Novembro", 12: "Dezembro",
};

export const labelOf = (map: LabelMap, id?: number | null) => (id !== undefined && id !== null ? map[id] ?? String(id) : "-");

export const mapToOptions = (map: LabelMap) =>
    Object.keys(map).map((key) => ({ value: key, label: map[Number(key)] }));

export const formatDate = (value?: string | null) => (value ? new Date(value).toLocaleDateString("pt-BR") : "-");

export const formatTime = (value?: string | null) => (value ? value.substring(0, 5) : "");

export const formatCurrency = (value?: number | null) =>
    value === undefined || value === null ? "-" : value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const yearOf = (value?: string | null) => (value ? new Date(value).getFullYear() : undefined);

export const yearOptions = (years: Array<number | undefined>) =>
    Array.from(new Set(years.filter((y): y is number => y !== undefined)))
        .sort((a, b) => b - a)
        .map((y) => ({ value: String(y), label: String(y) }));
